<template>
  <Tab
    v-slot="{ selected }"
    as="template"
  >
    <button
      :class="[
        'flex-1 text-sm font-medium text-default-500 border-b-2 outline-none',
        selected ? 'border-primary-500' : 'border-default-200',
        sizeClasses[size],
      ]"
    >
      <slot />
    </button>
  </Tab>
</template>

<script setup lang="ts">
import { Tab } from '@headlessui/vue';

withDefaults(defineProps<{
  size?: 'sm' | 'md';
}>(), {
  size: 'md',
});

const sizeClasses = {
  sm: 'py-base',
  md: 'py-lg',
};
</script>
